const CONSOLIDATION_CHANNEL  = 'consolidation_channel';

export default class ConstantConsolidation{

    static get CONSOLIDATION_CHANNEL(){
        return CONSOLIDATION_CHANNEL;
    }
}